import classNames from "classnames";
import { icons } from "../utils/icons";

interface CustomCheckboxProps {
   checked: boolean;
   onChange: (checked: boolean) => void;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
   checked,
   onChange,
}) => {
   return (
      <div
         className="h-5 w-5 border border-brown-300 bg-brown-200 flex items-center justify-center cursor-pointer"
         onClick={() => onChange(!checked)}
      >
         <div
            className={classNames(
               "scale-0 transition-all duration-100 h-3 w-3 text-brown-500",
               {
                  "scale-100": checked,
               }
            )}
         >
            {icons.check}
         </div>
      </div>
   );
};

export default CustomCheckbox;
